import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  buttonFix: {
    border: '1px solid #CD0021',
    borderRadius: '0px',
    fontFamily: 'Noto Sans JP',
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.8px',
    color: '#CD0021',
    padding: '0.42em 1.5em',
    backgroundColor: '#FFF',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '21px',
      letterSpacing: '0.28px',
    },
  },
}));

export default useStyles;
